import { Component, Inject } from 'ng-metadata/core';
import * as angular from 'angular';
import './header.scss';

/**
 * @name mwMediaSourceDocumentHeader
 * @module mw.components.contentDocuments
 *
 * @description
 * `<mw-media-source-document-header>` is a component used to show the content of the header.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 */

const template = `
    <div class="mw-media-source-document-header" layout="row">
        <ng-transclude class="mw-media-source-document-header__source-avatar" ng-transclude-slot="mwContentDocumentSourceAvatar"></ng-transclude>
        <div class="mw-media-source-document-header__detail" flex="100" layout="column" layout-align="space-between">
            <div class="mw-media-source-document-header__detail-first-row">
                <ng-transclude ng-transclude-slot="mwContentDocumentAuthor"></ng-transclude>
            </div>
            <div flex="initial" layout="row">
              <ng-transclude md-truncate flex="initial" ng-transclude-slot="mwMediaSourceDocumentGeofocus"></ng-transclude>
              <ng-transclude md-truncate flex="initial" ng-transclude-slot="mwMediaSourceDocumentWeb"></ng-transclude>
            </div>
            <div md-truncate ng-if="$ctrl.$transclude.isSlotFilled('mwMediaSourceDocumentAddress')">
                <ng-transclude ng-transclude-slot="mwMediaSourceDocumentAddress"></ng-transclude>
            </div>
        </div>
        <ng-transclude class="mw-media-source-document-header__actions" flex="noshrink" ng-transclude-slot="mwContentDocumentActions"><div></div></ng-transclude>
    </div>
`


@Component({
    selector: 'mw-media-source-document-header',
    template: template,
    legacy: {
        transclude: {
            mwContentDocumentActions: '?mwContentDocumentActions',
            mwMediaSourceDocumentAddress: '?mwMediaSourceDocumentAddress',
            mwContentDocumentSourceAvatar: '?mwContentDocumentSourceAvatar',
            mwContentDocumentAuthor: '?mwContentDocumentAuthor',
            mwMediaSourceDocumentWeb: '?mwMediaSourceDocumentWeb',
            mwMediaSourceDocumentGeofocus: '?mwMediaSourceDocumentGeofocus',
        }
    }
})
export class MediaSourceDocumentHeaderComponent {

    constructor(@Inject('$transclude') private $transclude: angular.ITranscludeFunction) {
        'ngInject'
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/header/header.component.ts